<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal"
    @base-modal:closed="handleCancelDeleteRecords"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Delete Event Records
      </h2>
    </template>
    <template #modal-body>
      <div class="Notice Notice--warning no-margin">
        Do you wish to delete {{ records.length }} records?
        <p>Text about this being <strong>permanent</strong></p>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--grey"
          @click="handleCancelDeleteRecords"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          class="Button Button--danger"
          @click="handleDeleteRecords"
        >
          Yes, Delete
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
  props: {
    records: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    hasMultipleRecords() {
      return this.records.length > 1;
    },
  },
  methods: {
    handleCancelDeleteRecords() {
      this.$emit('delete-records:cancel');
    },
    handleDeleteRecords() {
      this.$emit('delete-records:delete');
    },
  },
};
</script>
